module.exports = __webpack_public_path__ + "img/homeLogo.f8e27e73.png";